module.exports = __webpack_public_path__ + "static/media/FAQ white.2a5eeea1.svg";